<template>
  <PageVenueFilter :value="venueId" @input="$store.dispatch('pos/general/selectVenueId', $event)">
    <WaiterListOverview v-if="venueId" :venueId="venueId" />
  </PageVenueFilter>
</template>

<script>
import { mapGetters } from "vuex";
import PageVenueFilter from "@/components/Custom/PageVenueFilter.vue";
import WaiterListOverview from "./WaiterListOverview.vue";

export default {
  components: {
    PageVenueFilter,
    WaiterListOverview
  },
  computed: {
    ...mapGetters({
      venueId: "pos/general/selectedVenueId"
    })
  }
};
</script>